export const _en = {
    addButton: {
        label: "Instructor role"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    dialog: {
        add: {
            title: "Add a time code",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        },
        edit: {
            title: "edit a time code",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        }
    }
};


export const _fr = {
    addButton: {
        label: "Code horaire"
    },
    addButtonSeason: {
        label: "Table code horaire"
    },
    toggleDeleted: {
        label: "Afficher les données archivés"
    },
    dialog: {
        add: {
            title: "Ajout d'un code horaire",
            buttons: {
                save: "Sauvegarder",
                cancel: "Annuler"
            }
        },
        edit: {
            title: "Édition du code horaire",
            buttons: {
                save: "Sauvegarder",
                cancel: "Annuler"
            }
        }
    },
    dialogSeason: {
        add: {
            title: "Ajout d'une table pour les codes horaires",
            buttons: {
                save: "Sauvegarder",
                cancel: "Annuler"
            }
        }
    },
    tabTimeCode: {
        title: "Codes horaires"
    }
};